import { render, staticRenderFns } from "./register-type.vue?vue&type=template&id=0b89235e&"
import script from "./register-type.vue?vue&type=script&lang=js&"
export * from "./register-type.vue?vue&type=script&lang=js&"
import style0 from "./register-type.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports